export default __webpack_public_path__ + "media/design-system/icon/assets/brand/LG/downside-56356f361bdf91f385f8affa857d124b.svg";